import setDefaultPaymentMethod from './setDefaultPaymentMethod'
import addPaymentMethod from './addPaymentMethod'
import confirmPayment from './confirmPayment'
import confirmOneTimeDonation from './confirmOneTimeDonation'
import convertGift from './convertGift'
import createGift from './createGift'
import getHasPassword from './getHasPassword'
import requestLoginLink from './requestLoginLink'
import login from './login'
import awaitLoaderFetching from './awaitLoaderFetching'
import awaitGiftResults from './awaitGiftResults'

export default {
    setDefaultPaymentMethod,
    addPaymentMethod,
    confirmPayment,
    confirmOneTimeDonation,
    convertGift,
    createGift,
    getHasPassword,
    requestLoginLink,
    login,
    awaitLoaderFetching,
    awaitGiftResults,
}
